import { SkinTone } from "./coverageTypes";
export const SkinColor = {
    // Basic
    [SkinTone.BLACK]: "rgba(50, 53, 56, 1)",
    [SkinTone.GRAY]: "rgba(196, 196, 196, 1)",
    [SkinTone.WHITE]: "rgba(255, 255, 255, 1)",
    // Monk
    [SkinTone.BROWN_0]: "rgba(246, 237, 228, 1)",
    [SkinTone.BROWN_1]: "rgba(243, 231, 219, 1)",
    [SkinTone.BROWN_2]: "rgba(247, 234, 208, 1)",
    [SkinTone.BROWN_3]: "rgba(234, 218, 186, 1)",
    [SkinTone.BROWN_4]: "rgba(215, 189, 150, 1)",
    [SkinTone.BROWN_5]: "rgba(160, 126, 86, 1)",
    [SkinTone.BROWN_6]: "rgba(130, 92, 67, 1)",
    [SkinTone.BROWN_7]: "rgba(96, 65, 52, 1)",
    [SkinTone.BROWN_8]: "rgba(58, 49, 42, 1)",
    [SkinTone.BROWN_9]: "rgba(41, 36, 32, 1)",
};
